export interface GetRequest {
  get: unknown;
}

export type KeysMatching<T extends object, V> = {
  [K in keyof T]-?: T[K] extends V ? K : never;
}[keyof T];

export type APIErrorResponseValue = string | string[];

export const isAPIErrorResponseValue = (
  error: unknown
): error is APIErrorResponseValue => {
  if (typeof error === "string") {
    return true;
  }

  if (Array.isArray(error)) {
    return error.every((err) => typeof err === "string");
  }

  return false;
};

export type APIFieldErrors = Record<string, APIErrorResponseValue | object>;

export type APIErrorResponse = Record<string, APIFieldErrors> & {
  detail?: string;
  non_field_errors?: APIErrorResponseValue;
};

export const isAPIErrorResponse = (
  error: unknown
): error is APIErrorResponse => {
  if (error === null || typeof error !== "object" || Array.isArray(error)) {
    return false;
  }

  if ("detail" in error && typeof error.detail !== "string") {
    return false;
  }

  return true;
};
